"use strict";
import { List, Record } from "immutable";
const isNeed = (object) => object && (object.__type__ === "need" || object.__type__ === "needCollection");
export default {
  load(model, hash, effects = List.of()) {
    const needs = _.select(_.values(hash), isNeed);
    if (_.isEmpty(needs)) {
      return List.of(
        model.set("isLoaded", true).set("data", Record(hash)()),
        effects
      );
    }
    return List.of(
      model.set("isLoaded", false).set("data", null),
      List(needs).concat(effects)
    );
  },
  load2(model, hash, effects = List.of()) {
    const needs = _.select(_.values(hash), isNeed);
    if (_.isEmpty(needs)) {
      return List.of(
        model.set("isLoaded2", true).set("data2", Record(hash)()),
        effects
      );
    }
    return List.of(
      model.set("isLoaded2", false).set("data2", null),
      List(needs).concat(effects)
    );
  }
};
